import React, { useState, useMemo, useEffect, useRef } from "react";
import {
  Search,
  User,
  Calendar,
  Package,
  IndianRupee,
  Wallet,
  Clock,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  User2,
  Download,
  FileSpreadsheet,
  HandCoins,
  X,
} from "lucide-react";
import { getCustomerProductList } from "../../services/customerServices";
import {
  createCustomerLedgerPendingPayment,
  getAllCustomerSerachStoreOwner,
  getAllCustomerSerachStoreWiseList,
  getCustomerLedgerReportList,
} from "../../services/storeOwnerOrderServices";
import { notify } from "../../components/Common/Alerts";
import Utils from "../../utils";
import CONFIG from "../../config";
import { decryptData } from "../../utils/crypto";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import { useConfig } from "../../components/Context/ConfigContext";
import { Check2 } from "react-bootstrap-icons";
import { useLocation } from "react-router-dom";

const monthsMap = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};

const CustomerLedger = () => {
  const { t } = useTranslation();
  const pdfRef = useRef();

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
  const { configData } = useConfig();
  const state = useLocation();
  const filters = state.state?.filters;
  const currentDate = new Date();
  const months = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", {
      month: "long",
    }),
  );
  const [month, setMonth] = useState(
    filters?.selectedMonth ||
      currentDate.toLocaleString("default", { month: "long" }),
  );

  const [year, setYear] = useState(
    filters?.selectedYear || currentDate.getFullYear().toString(),
  );
  const [expandedProduct, setExpandedProduct] = useState(null);
  const [currentStartIndex, setCurrentStartIndex] = useState(0);
  const [customerList, setCustomerList] = useState([]);
  const [productList, setProductList] = useState([]);
  const daysPerPage = 10;
  const storedData = JSON.parse(localStorage.getItem(CONFIG.login_data));
  const [selectedCustomer, setSelectedCustomer] = useState(
    filters?.selectedCustomer || "",
  );

  const [customer, setCustomer] = useState({});
  const [ledgerProducts, setLedgerProducts] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [dayTotals, setDayTotals] = useState({});
  const [loading, setLoading] = useState(false);
  const [appliedMonth, setAppliedMonth] = useState("May");
  const [appliedYear, setAppliedYear] = useState("2026");
  const [summary, setSummary] = useState({
    total_qty: 0,
    total_amount: 0,
    paid_amount: 0,
    pending_amount: 0,
  });
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [formdata, setFormdata] = useState({
    order_uuid: "",
    amount: "",
    payment_method: "",
  });
  const [errors, setErrors] = useState({
    amount: "",
    payment_method: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [paymentmethod, setPaymentMethod] = useState("");

  const handlePaymentOpenModel = () => {
    setIsPaymentModalOpen(true);
  };

  const validateField = (name, value) => {
    switch (name) {
      case "amount":
        if (!value) return t("amountIsRequired");
        return "";
      case "payment_method":
        if (!value) return t("paymentMethodIsRequired");
        return "";

      default:
        return "";
    }
  };

  useEffect(() => {
    if (filters) {
      setMonth(filters.selectedMonth || "");
      setYear(filters.selectedYear || "");
      setSelectedCustomer(filters.selectedCustomer || "");
    }
  }, [filters]);



  // const generateDays = (monthName, yearValue) => {
  //   const monthIndex = monthsMap[monthName];

  //   const totalDays = new Date(Number(yearValue), monthIndex + 1, 0).getDate();

  //   const days = [];

  //   for (let i = 1; i <= totalDays; i++) {
  //     const dateObj = new Date(yearValue, monthIndex, i);

  //     days.push({
  //       date: i,
  //       day: dateObj.toLocaleDateString("en-US", {
  //         weekday: "short",
  //       }),
  //       isSunday: dateObj.getDay() === 0,
  //     });
  //   }

  //   setAllDaysConfig(days);

  //   setCurrentStartIndex(0);
  // };

  const fetchLedger = async () => {
    try {
      if (!selectedCustomer?.value) {
        return notify.error("Please select customer");
      }

      setLoading(true);

      const payload = {
        customer_id: Number(selectedCustomer?.value),
        month,
        year,
        store_id: Number(storedData?.active_store_id),
      };

      const response = await getCustomerLedgerReportList(payload);
      const decrypted = decryptData(response.data.data);

      setCustomer(decrypted?.data?.customer || {});
      setLedgerProducts(decrypted?.data?.products || []);

      setSummary(
        decrypted?.data?.summary || {
          total_qty: 0,
          total_amount: 0,
          paid_amount: 0,
          pending_amount: 0,
        },
      );
      setTopProducts(decrypted?.data?.top_products || []);
      setDayTotals(decrypted?.data?.day_totals || {});
      setAppliedMonth(month);
      setAppliedYear(year);
      // generateDays(month, year);
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const getProductRowStats = (product) => {
    return {
      totalQty: product?.total_qty || 0,
      totalPrice: product?.total_amount || 0,
    };
  };

  const getDayTotal = (dateKey) => {
    return {
      qty: dayTotals?.[dateKey]?.qty || 0,
      price: dayTotals?.[dateKey]?.amount || 0,
    };
  };

  const grandTotalQty = summary?.total_qty || 0;
  const grandTotalAmount = summary?.total_amount || 0;

  useEffect(() => {
    const data = {
      search: "",
      page: "",
      limit: "",
    };

    getAllCustomerSerachStoreWiseList(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        setCustomerList(decrypted.data || []);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  const customerOptions = customerList.map((customer) => ({
    value: customer.id,
    label: customer.name,
    mobile: customer.mobile,
    image: customer.profile_image,
  }));

  useEffect(() => {
    const data = {
      store_id: storedData?.active_store_id,
      category_ids: [],
      search: "",
      page: "",
      limit: 10,
    };

    getCustomerProductList(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        setProductList(decrypted.data);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);


  const allDaysConfig = useMemo(() => {
    const monthIndex = monthsMap[month];
    const yearNum = parseInt(year, 10);

    const totalDays = new Date(yearNum, monthIndex + 1, 0).getDate();
    const daysArray = [];
    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    for (let d = 1; d <= totalDays; d++) {
      const dateString = d < 10 ? `0${d}` : `${d}`;
      const dayIndex = new Date(yearNum, monthIndex, d).getDay();

      daysArray.push({
        date: dateString,
        day: dayNames[dayIndex],
        // isSunday: dayIndex === 0,
      });
    }
    setCurrentStartIndex(0);
    return daysArray;
  }, [month, year]);

  const visibleDays = useMemo(() => {
    return allDaysConfig.slice(
      currentStartIndex,
      currentStartIndex + daysPerPage,
    );
  }, [allDaysConfig, currentStartIndex]);

  const handlePrevDays = () => {
    setCurrentStartIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNextDays = () => {
    setCurrentStartIndex((prev) =>
      Math.min(allDaysConfig?.length - daysPerPage, prev + 1),
    );
  };

  // const getProductRowStats = (product) => {
  //   let totalQty = 0;
  //   allDaysConfig.forEach((d) => {
  //     const qty = product.days[d.date] || 0;
  //     totalQty += qty;
  //   });
  //   return { totalQty, totalPrice: totalQty * product.price };
  // };

  // const getDayTotal = (dateKey) => {
  //   let totalAmount = 0;
  //   let totalQty = 0;
  //   initialProducts.forEach((p) => {
  //     const qty = p.days[dateKey] || 0;
  //     totalQty += qty;
  //     totalAmount += qty * p.price;
  //   });
  //   return { qty: totalQty, price: totalAmount };
  // };

  // const grandTotalQty = initialProducts.reduce(
  //   (acc, p) => acc + getProductRowStats(p).totalQty,
  //   0,
  // );
  // const grandTotalAmount = initialProducts.reduce(
  //   (acc, p) => acc + getProductRowStats(p).totalPrice,
  //   0,
  // );

  const handleDownloadPDF = async () => {
    if (!selectedCustomer) {
      notify.error("Please select customer");
      return;
    }

    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    // ================= HEADER (ONLY ONCE) =================
    pdf.setFillColor(226, 112, 18);
    pdf.rect(0, 0, pageWidth, 34, "F");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(24);
    pdf.setFont(undefined, "bold");
    pdf.text("CUSTOMER REPORT", 14, 18);

    pdf.setFontSize(11);
    pdf.setFont(undefined, "normal");
    pdf.text("Professional Monthly Statement", 14, 27);

    // ================= CUSTOMER INFO =================
    pdf.setFillColor(248, 250, 252);
    pdf.roundedRect(14, 42, pageWidth - 28, 34, 4, 4, "F");

    pdf.setTextColor(120);
    pdf.setFontSize(10);
    pdf.setFont(undefined, "bold");
    pdf.text("CUSTOMER NAME", 22, 54);

    pdf.setTextColor(15, 23, 42);
    pdf.setFontSize(18);
    pdf.text(customer?.name || "-", 22, 67);

    pdf.setTextColor(120);
    pdf.setFontSize(10);
    pdf.text("MOBILE NUMBER", 120, 54);

    pdf.setTextColor(15, 23, 42);
    pdf.setFontSize(18);
    pdf.text(customer?.mobile || "-", 120, 67);

    pdf.setTextColor(120);
    pdf.setFontSize(10);
    pdf.text("STATEMENT WINDOW", 220, 54);

    pdf.setTextColor(15, 23, 42);
    pdf.setFontSize(18);
    pdf.text(`${appliedMonth} ${appliedYear}`, 220, 67);

    // ================= SUMMARY CARDS =================
    const cards = [
      {
        title: "TOTAL QTY",
        value: grandTotalQty,
        color: [59, 130, 246],
      },
      {
        title: "TOTAL AMOUNT",
        value: `Rs.${grandTotalAmount.toLocaleString("en-IN")}`,
        color: [249, 115, 22],
      },
      {
        title: "PAID AMOUNT",
        value: `Rs.${summary?.paid_amount?.toLocaleString("en-IN") || 0}`,
        color: [16, 185, 129],
      },
      {
        title: "PENDING",
        value: `Rs.${summary?.pending_amount?.toLocaleString("en-IN") || 0}`,
        color: [239, 68, 68],
      },
    ];

    cards.forEach((card, i) => {
      const x = 14 + i * 72;

      pdf.setFillColor(...card.color);
      pdf.roundedRect(x, 88, 64, 28, 4, 4, "F");

      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(9);
      pdf.setFont(undefined, "bold");
      pdf.text(card.title, x + 4, 98);

      pdf.setFontSize(16);
      pdf.text(String(card.value), x + 4, 110);
    });

    // ================= PAGINATION SETUP =================
    const chunkSize = 10;
    const dayChunks = [];

    for (let i = 0; i < allDaysConfig.length; i += chunkSize) {
      dayChunks.push(allDaysConfig.slice(i, i + chunkSize));
    }

    // ================= TABLE PAGES =================
    dayChunks.forEach((daysChunk, pageIndex) => {
      if (pageIndex > 0) {
        pdf.addPage();
      }

      const head = [
        [
          "Product",
          ...daysChunk.map((d) => `${d.date}\n${d.day}`),
          "Total Qty",
          "Total Amount",
        ],
      ];

      const body = ledgerProducts.map((product) => {
        const row = [];

        row.push(product.product_name);

        daysChunk.forEach((d) => {
          const qty = product.days?.[d.date]?.qty || 0;
          const amount = product.days?.[d.date]?.amount || 0;

          row.push(qty > 0 ? `${qty} Qty\nRs.${amount}` : "-");
        });

        const stats = getProductRowStats(product);

        row.push(stats.totalQty);
        row.push(`Rs.${stats.totalPrice.toLocaleString("en-IN")}`);

        return row;
      });

      const totalRow = ["DAY TOTAL"];

      daysChunk.forEach((d) => {
        const dayData = getDayTotal(d.date);

        totalRow.push(
          dayData.qty > 0 ? `${dayData.qty}\nRs.${dayData.price}` : "-",
        );
      });

      totalRow.push(grandTotalQty);
      totalRow.push(`Rs.${grandTotalAmount.toLocaleString("en-IN")}`);

      body.push(totalRow);

      autoTable(pdf, {
        startY: pageIndex === 0 ? 128 : 20,
        head,
        body,
        theme: "grid",

        styles: {
          fontSize: 11,
          cellPadding: 4,
          halign: "center",
          valign: "middle",
          lineColor: [253, 186, 116],
          lineWidth: 0.3,
        },

        headStyles: {
          fillColor: [226, 112, 18],
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },

        alternateRowStyles: {
          fillColor: [255, 247, 237],
        },

        columnStyles: {
          0: {
            cellWidth: 55,
            halign: "left",
            fontStyle: "bold",
          },
        },

        didParseCell: function (data) {
          if (
            data.section === "head" &&
            data.column.index > 0 &&
            data.column.index <= daysChunk.length
          ) {
            const day = daysChunk[data.column.index - 1];
            if (day?.isSunday) {
              data.cell.styles.fillColor = [254, 242, 242];
              data.cell.styles.textColor = [220, 38, 38];
            }
          }

          if (data.row.index === body.length - 1) {
            data.cell.styles.fillColor = [255, 237, 213];
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.textColor = [154, 52, 18];
          }
        },

        margin: {
          left: 14,
          right: 14,
        },

        didDrawPage: function () {
          pdf.setFontSize(9);
          pdf.setTextColor(120);

          pdf.text(
            `Generated On : ${moment().format("DD MMM YYYY hh:mm A")}`,
            14,
            pageHeight - 10,
          );

          pdf.text(
            `Page ${pageIndex + 1} of ${dayChunks.length}`,
            pageWidth - 45,
            pageHeight - 10,
          );
        },
      });
    });

    pdf.save(
      `${customer?.name || "Customer"}-${appliedMonth}-${appliedYear}.pdf`,
    );
  };
  const handleExportCSV = () => {
    if (!selectedCustomer) {
      notify.error("Please select customer");
      return;
    }

    const headers = [
      "Product Name",
      ...allDaysConfig.map((d) => `${d.date} ${d.day}`),
      "Total Qty",
      "Total Amount",
    ];

    const rows = ledgerProducts.map((product) => {
      const row = [];

      row.push(product.product_name);

      allDaysConfig.forEach((d) => {
        const qty = product.days?.[d.date]?.qty || 0;
        const amount = product.days?.[d.date]?.amount || 0;

        row.push(qty > 0 ? `${qty} Qty / ₹${amount}` : "-");
      });

      const stats = getProductRowStats(product);

      row.push(stats.totalQty);
      row.push(stats.totalPrice);

      return row;
    });

    // Day Total Row
    const totalRow = ["DAY TOTAL"];

    allDaysConfig.forEach((d) => {
      const dayData = getDayTotal(d.date);

      totalRow.push(
        dayData.qty > 0 ? `${dayData.qty} Qty / ₹${dayData.price}` : "-",
      );
    });

    totalRow.push(grandTotalQty);
    totalRow.push(grandTotalAmount);

    rows.push(totalRow);

    // Customer Info
    const customerInfo = [
      [`Customer Name`, customer?.name || "-"],
      [`Mobile`, customer?.mobile || "-"],
      [`Month`, `${appliedMonth} ${appliedYear}`],
      [],
    ];

    const csvContent = [
      ...customerInfo.map((row) => row.join(",")),
      headers.join(","),
      ...rows.map((row) => row.map((item) => `"${item}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `${customer?.name || "Customer"}-${appliedMonth}-${appliedYear}.csv`,
    );

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const handlePendingPaymentSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      amount: validateField("amount", formdata.amount),
      payment_method: validateField("payment_method", paymentmethod),
    };
    Utils.focusError();
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((err) => err);

    if (hasErrors) return;

    setIsSubmitting(true);

    const payload = {
      customer_id: selectedCustomer?.value,
      amount: formdata?.amount,
      payment_method: paymentmethod,
      store_id: Number(storedData?.active_store_id),
    };

    try {
      const response = await createCustomerLedgerPendingPayment(payload);
      const decrypted = decryptData(response.data);
      notify.success(decrypted.message);
      setFormdata({
        order_uuid: "",
        amount: "",
        payment_method: "",
      });
      setErrors({
        amount: "",
        payment_method: "",
      });
      setIsPaymentModalOpen(false);
      fetchLedger();
      setPaymentMethod("");
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-[#F8FAFC] p-4 sm:p-6 text-slate-700 font-sans antialiased tracking-wide mb-10">
      <div className="bg-white rounded-2xl border border-slate-100 p-5 shadow-sm mb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
          <div>
            <label className="block text-[11px] font-semibold text-slate-500 dark:text-slate-400 mb-2">
              {t("selectCustomer")}
            </label>

            <div className="relative">
              <User className="absolute left-3 top-3 w-4 h-4 text-slate-400 dark:text-slate-500" />

              <Select
                options={customerOptions}
                placeholder="Select Customer"
                onChange={(selected) => setSelectedCustomer(selected || "")}
                className="text-xs"
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                formatOptionLabel={(data) => (
                  <div className="flex items-center gap-2 py-1">
                    {data.image ? (
                      <img
                        src={data.profile_image}
                        alt={data.label}
                        className="w-8 h-8 rounded-full object-cover border"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "flex";
                        }}
                      />
                    ) : null}

                    <div
                      className={`w-8 h-8 rounded-full bg-slate-100 border items-center justify-center ${
                        data?.image ? "hidden" : "flex"
                      }`}
                    >
                      <User2 className="w-4 h-4 text-slate-500" />
                    </div>

                    <div>
                      <p className="text-sm font-medium text-slate-800">
                        {data?.label}
                      </p>

                      <p className="text-xs text-slate-500">{data?.mobile}</p>
                    </div>
                  </div>
                )}
                isClearable
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">
              {t("month")}
            </label>
            <select
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-800 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all cursor-pointer"
            >
              {Object.keys(monthsMap).map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">
              {t("year")}
            </label>
            <select
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-800 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all cursor-pointer"
            >
              {years?.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={fetchLedger}
            disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm h-[44px] rounded-xl flex items-center justify-center gap-2 shadow-sm transition-all cursor-pointer disabled:opacity-50"
          >
            <Search size={16} strokeWidth={2.5} />

            {loading ? t("loading") : t("filter")}
          </button>
        </div>
      </div>
      <div id="ledger-report-container" className="w-full">
        <div className="bg-white border border-slate-100 rounded-2xl p-4 lg:p-5 mb-6 flex flex-col lg:flex-row lg:items-center justify-between gap-5 shadow-sm">
          {/* Left Side: Customer Info Section */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 pb-4 lg:pb-0 border-b border-slate-100 lg:border-b-0 shrink-0">
            <div className="flex items-center gap-3.5">
              <div className="w-11 h-11 bg-slate-50 rounded-full flex items-center justify-center text-slate-500 shrink-0 border border-slate-100">
                <User size={18} />
              </div>
              <div>
                <span className="block text-[10px] uppercase font-bold tracking-widest text-slate-400 leading-tight mb-0.5">
                  {t("customerName")}
                </span>
                <span className="text-base font-bold text-slate-800 whitespace-nowrap">
                  {customer?.name || "-"}
                </span>
              </div>
            </div>

            <div className="pl-1 sm:pl-6 sm:border-l sm:border-slate-200/60">
              <span className="block text-[10px] uppercase font-bold tracking-widest text-slate-400 leading-tight mb-0.5">
                {t("mobileNumber")}
              </span>
              <span className="text-base font-bold text-slate-700 whitespace-nowrap">
                {customer?.mobile || "-"}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 md:flex md:flex-row md:items-center gap-2.5 w-full lg:w-auto no-pdf">
            {Number(summary?.pending_amount) > 0 && (
              <button
                onClick={handlePaymentOpenModel}
                className="flex items-center justify-center gap-1.5 bg-orange-500 hover:bg-orange-600 text-white font-bold text-xs px-4 py-2.5 rounded-xl transition-all shadow-sm cursor-pointer border border-transparent whitespace-nowrap order-1"
              >
                <HandCoins size={14} strokeWidth={2.5} />
                {t("payPendingAmount")}
              </button>
            )}

            <button
              onClick={handleDownloadPDF}
              className={`flex items-center justify-center gap-1.5 bg-orange-500 hover:bg-orange-600 text-white font-bold text-xs px-4 py-2.5 rounded-xl transition-all shadow-sm cursor-pointer border border-transparent whitespace-nowrap order-2 ${
                Number(summary?.pending_amount) <= 0
                  ? "col-span-2 md:col-span-1"
                  : ""
              }`}
            >
              <Download size={14} strokeWidth={2.5} />
              {t("downloadPDF")}
            </button>

            <button
              onClick={handleExportCSV}
              className="flex items-center justify-center gap-1.5 bg-orange-50 hover:bg-orange-100/80 text-orange-600 font-bold text-xs px-4 py-2.5 rounded-xl transition-all shadow-xs cursor-pointer border border-orange-200/60 whitespace-nowrap order-3"
            >
              <FileSpreadsheet size={14} strokeWidth={2.5} />
              {t("exportCSV")}
            </button>

            <div className="flex items-center gap-2.5 bg-slate-50 border border-slate-200/60 px-3 py-2 rounded-xl order-4 col-span-1 min-w-0">
              <Calendar size={14} className="text-slate-400 shrink-0" />
              <div className="min-w-0">
                <span className="block text-[9px] text-slate-400 uppercase font-bold tracking-wider leading-tight whitespace-nowrap">
                  {t("statementWindow")}
                </span>
                <span className="text-xs font-bold text-slate-700 block truncate">
                  {appliedMonth} {appliedYear}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6 items-start">
        <div className="xl:col-span-3 relative">
          <div
            ref={pdfRef}
            className="hidden md:block bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden overflow-x-auto max-h-[900px] overflow-y-auto"
          >
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse table-fixed min-w-[1000px]">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-200 text-[11px] font-bold text-slate-500 uppercase tracking-wider">
                    <th className="w-52 p-4 text-slate-700 font-extrabold text-xs sticky left-0 bg-slate-50 z-20 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.05)] relative group">
                      <span>{t("productDetails")}</span>
                      <button
                        onClick={handlePrevDays}
                        disabled={currentStartIndex === 0}
                        className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 bg-[#0B192C] text-white rounded-lg flex items-center justify-center hover:bg-slate-800 disabled:opacity-0 disabled:pointer-events-none transition-all cursor-pointer border border-slate-700 shadow-xs"
                        title="Previous Days"
                      >
                        <ChevronLeft size={14} strokeWidth={3} />
                      </button>
                    </th>

                    {visibleDays?.map((d, idx) => (
                      <th
                        key={idx}
                        className={`p-2 text-center border-l border-slate-200/60 ${d.isSunday ? "bg-red-50 text-red-600 font-black" : ""}`}
                      >
                        <div className="text-xs font-bold">{d.date}</div>
                        <div className="text-[10px] font-medium opacity-70">
                          {d.day}
                        </div>
                      </th>
                    ))}

                    <th className="w-32 p-4 text-center border-l border-slate-200 bg-slate-100 font-bold text-slate-700 text-xs sticky right-0 z-20 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.05)] relative group">
                      <button
                        onClick={handleNextDays}
                        disabled={
                          currentStartIndex + daysPerPage >=
                          allDaysConfig.length
                        }
                        className="absolute left-2 top-1/2 -translate-y-1/2 w-7 h-7 bg-[#0B192C] text-white rounded-lg flex items-center justify-center hover:bg-slate-800 disabled:opacity-0 disabled:pointer-events-none transition-all cursor-pointer border border-slate-700 shadow-xs"
                        title="Next Days"
                      >
                        <ChevronRight size={14} strokeWidth={3} />
                      </button>
                      <span className="block w-full text-center pl-4">
                        {t("totalMonthAccum")}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200/80 text-xs font-medium">
                  {ledgerProducts?.map((product, index) => {
                    const { totalQty, totalPrice } =
                      getProductRowStats(product);
                    return (
                      <tr
                        key={index}
                        className="hover:bg-slate-50/50 transition-colors group"
                      >
                        <td className="p-4 bg-white sticky left-0 font-medium group-hover:bg-slate-50/50 z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.05)]">
                          <div className="font-bold text-slate-900 text-[14px] tracking-tight">
                            {product.product_name}
                          </div>
                        </td>
                        {visibleDays.map((d, idx) => {
                          const val = product.days?.[d.date]?.qty || 0;
                          const amount = product.days?.[d.date]?.amount || 0;
                          return (
                            <td
                              key={idx}
                              className={`p-2 text-center border-l border-slate-150 ${d.isSunday ? "bg-red-50/20" : ""}`}
                            >
                              {val !== undefined && val > 0 ? (
                                <div className="py-0.5">
                                  <div className="font-extrabold text-slate-900 text-[15px]">
                                    {val}
                                  </div>
                                  <div className="text-[11px] text-slate-700 font-bold bg-slate-100 rounded px-1 py-0.5 mt-1 inline-block">
                                    ₹{amount}
                                  </div>
                                </div>
                              ) : (
                                <span className="text-slate-300 font-bold">
                                  —
                                </span>
                              )}
                            </td>
                          );
                        })}
                        <td className="p-2 text-center bg-slate-50 border-l border-slate-200 text-slate-900 sticky right-0 z-10 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.05)]">
                          <div className="text-[14px] font-black text-slate-900">
                            {totalQty}{" "}
                            <span className="text-[10px] font-normal text-slate-400">
                              {t("Qty")}
                            </span>
                          </div>
                          <div className="text-xs font-extrabold text-orange-600 bg-orange-50 border border-orange-100 rounded py-1 px-1.5 mt-1 inline-block">
                            ₹{totalPrice.toLocaleString("en-IN")}
                          </div>
                        </td>
                      </tr>
                    );
                  })}

                  <tr className="bg-slate-100 font-bold text-slate-900 border-t-2 border-slate-200">
                    <td className="p-4 text-xs font-extrabold uppercase text-slate-600 tracking-wider sticky left-0 bg-slate-100 z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.05)]">
                      {t("dayTotal")}
                    </td>
                    {visibleDays.map((d, idx) => {
                      const dayData = getDayTotal(d.date);
                      return (
                        <td
                          key={idx}
                          className="p-2 text-center border-l border-slate-200"
                        >
                          {dayData.qty > 0 ? (
                            <div>
                              <div className="text-xs font-black text-slate-900">
                                {dayData.qty}
                              </div>
                              <div className="text-[11px] font-bold text-slate-700 mt-0.5">
                                ₹{dayData.price}
                              </div>
                            </div>
                          ) : (
                            <span className="text-slate-300">—</span>
                          )}
                        </td>
                      );
                    })}
                    <td className="p-2 text-center bg-orange-600 text-white border-l border-orange-700 font-black sticky right-0 z-10 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.05)]">
                      <div className="text-xs font-bold uppercase tracking-wider opacity-90">
                        {grandTotalQty} {t("Pcs")}
                      </div>
                      <div className="text-sm font-black mt-0.5">
                        ₹{grandTotalAmount.toLocaleString("en-IN")}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="block md:hidden space-y-3">
            {ledgerProducts?.map((product, index) => {
              const { totalQty, totalPrice } = getProductRowStats(product);
              const isExpanded = expandedProduct === product.id;

              return (
                <div
                  key={index}
                  className="bg-white border border-slate-200 rounded-xl shadow-xs overflow-hidden"
                >
                  <div
                    onClick={() =>
                      setExpandedProduct(isExpanded ? null : product.id)
                    }
                    className="p-4 flex items-center justify-between gap-2 active:bg-slate-50 cursor-pointer"
                  >
                    <div>
                      <h4 className="font-bold text-sm text-slate-900">
                        {product.product_name}
                      </h4>
                    </div>
                    <div className="flex items-center gap-3 text-right shrink-0">
                      <div>
                        <div className="text-sm font-black text-slate-900">
                          {totalQty} {t("Qty")}
                        </div>
                        <div className="text-xs font-bold text-orange-600 mt-0.5">
                          ₹{totalPrice}
                        </div>
                      </div>
                      <div className="text-slate-400">
                        {isExpanded ? (
                          <ChevronUp size={16} />
                        ) : (
                          <ChevronDown size={16} />
                        )}
                      </div>
                    </div>
                  </div>

                  {isExpanded && (
                    <div className="bg-slate-50 p-3 border-t border-slate-150">
                      <div className="grid grid-cols-4 gap-2 text-center">
                        {allDaysConfig.map((d, idx) => {
                          const val = product.days?.[d.date]?.qty || 0;
                          const amount = product.days?.[d.date]?.amount || "-";
                          return (
                            <div
                              key={idx}
                              className={`p-2 rounded-xl border ${val > 0 ? "bg-white border-orange-200 shadow-3xs" : "border-slate-200/60 bg-white/40"}`}
                            >
                              <div
                                className={`text-[10px] font-bold ${d.isSunday ? "text-red-500" : "text-slate-400"}`}
                              >
                                {d.date} {d.day}
                              </div>
                              {val !== undefined && val > 0 ? (
                                <>
                                  <div
                                    className={`text-base font-black mt-0.5 ${val > 0 ? "text-slate-900" : "text-slate-300"}`}
                                  >
                                    {val}
                                  </div>
                                  {val > 0 && (
                                    <div className="text-[11px] text-slate-700 font-bold bg-slate-100 rounded px-1 py-0.5 mt-1 inline-block">
                                      ₹{amount}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  <span className="text-slate-300 font-bold">
                                    —
                                  </span>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="grid grid-cols-2 xl:grid-cols-1 gap-4 order-last xl:order-none">
          <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
            <div className="w-10 h-10 bg-slate-50 rounded-xl flex items-center justify-center text-slate-500 shrink-0 border border-slate-100">
              <Package size={16} />
            </div>
            <div>
              <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                {t("totalQuantity")}
              </span>
              <span className="text-xl font-bold text-slate-800 mt-0.5 block tracking-tight">
                {grandTotalQty}
              </span>
            </div>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
            <div className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center text-orange-500 shrink-0 border border-orange-100">
              <IndianRupee size={16} />
            </div>
            <div>
              <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                {t("totalAmount")}
              </span>
              <span className="text-xl font-bold text-orange-600 mt-0.5 block tracking-tight">
                ₹{grandTotalAmount.toLocaleString("en-IN")}
              </span>
            </div>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
            <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center text-emerald-600 shrink-0 border border-emerald-100">
              <Wallet size={16} />
            </div>
            <div>
              <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                {t("paidAmount")}
              </span>
              <span className="text-xl font-bold text-emerald-600 mt-0.5 block tracking-tight">
                ₹{summary?.paid_amount?.toLocaleString("en-IN")}
              </span>
            </div>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
            <div className="w-10 h-10 bg-red-50 rounded-xl flex items-center justify-center text-red-500 shrink-0 border border-red-100">
              <Clock size={16} />
            </div>
            <div>
              <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                {t("pendingAmount")}
              </span>
              <span className="text-xl font-bold text-red-600 mt-0.5 block tracking-tight">
                ₹{summary?.pending_amount?.toLocaleString("en-IN")}
              </span>
            </div>
          </div>

          {topProducts?.length > 0 && (
            <div className="col-span-2 xl:col-span-1 bg-white border border-slate-200 rounded-xl p-4 shadow-xs">
              <h4 className="text-[10px] font-bold uppercase tracking-wider text-slate-400 border-b border-slate-100 pb-2.5 mb-3">
                {t("topPerformanceProducts")}
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-5 xl:grid-cols-1 gap-2 mb-10">
                {topProducts.slice(0, 5).map((p, i) => (
                  <div
                    key={i}
                    className="flex justify-between items-center bg-slate-50 border border-slate-100/60 px-3 py-1.5 rounded-lg text-xs font-semibold"
                  >
                    <span className="text-slate-600 truncate">
                      {i + 1}. {p.product_name}
                    </span>
                    <span className="font-bold text-slate-800 bg-white border border-slate-200 rounded px-1.5 py-0.5 text-[11px]">
                      {p.qty}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {isPaymentModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center p-0 md:p-4">
          <div className="absolute inset-0 bg-black/40 backdrop-blur-md" />
          <div className="relative w-full max-w-md bg-white dark:bg-slate-900 rounded-t-[2.5rem] md:rounded-[2rem] shadow-2xl overflow-hidden animate-in slide-in-from-bottom duration-300">
            <div className="p-8 border-b dark:border-slate-800 flex justify-between items-center bg-gray-50/50 dark:bg-slate-800/50">
              <h3 className="text-2xl font-black text-gray-900 dark:text-white">
                {t("updatePayment")}
              </h3>
              <button
                onClick={() => {
                  setIsPaymentModalOpen(false);
                  setErrors({ amount: "", payment_method: "" });
                  setFormdata({
                    amount: "",
                    payment_method: "",
                  });
                  setPaymentMethod("");
                }}
                className="p-2 hover:bg-gray-200 dark:hover:bg-slate-700 rounded-full transition-colors text-zinc-500 dark:text-slate-400"
              >
                <X size={28} />
              </button>
            </div>

            <form
              onSubmit={handlePendingPaymentSubmit}
              className="p-8 space-y-6"
            >
              <div>
                <label className="input-label dark:text-slate-300">
                  {t("amount")}
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={4}
                  value={formdata.amount}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
                    setFormdata({ ...formdata, amount: value });
                  }}
                  placeholder={t("enterAmount")}
                  className={`input-field dark:bg-slate-800 dark:border-slate-700 dark:text-white ${
                    errors.amount ? "input-error" : ""
                  }`}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key))
                      e.preventDefault();
                  }}
                />
                {errors.amount && (
                  <span className={`text-danger mt-1`}>{errors.amount}</span>
                )}
              </div>
              <div>
                <label className="input-label dark:text-slate-300">
                  {t("paymentMethod")}
                </label>
                <div className="flex bg-slate-100 dark:bg-slate-800 p-1.5 rounded-2xl">
                  {configData?.payment_method?.slice(1).map((type) => (
                    <button
                      type="button"
                      key={type.value}
                      onClick={() => setPaymentMethod(type.value)}
                      className={`flex-1 py-3 rounded-xl font-bold text-sm transition-all ${
                        paymentmethod === type.value
                          ? "bg-[#E67E22] text-white shadow-md"
                          : "text-slate-500 dark:text-slate-400"
                      }`}
                    >
                      {type.label}
                    </button>
                  ))}
                </div>
                {errors.payment_method && (
                  <span className={`text-danger mt-1`}>
                    {errors.payment_method}
                  </span>
                )}
              </div>

              <div className="pt-4 grid grid-cols-2 gap-4">
                <button
                  type="button"
                  onClick={() => {
                    setIsPaymentModalOpen(false);
                    setErrors({ amount: "", payment_method: "" });
                    setFormdata({
                      order_uuid: "",
                      amount: "",
                      payment_method: "",
                    });
                    setPaymentMethod("");
                  }}
                  className="py-4 border-2 border-gray-100 dark:border-slate-800 rounded-2xl font-black text-gray-400 dark:text-slate-500 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  {t("cancel")}
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="py-4 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-black shadow-lg shadow-orange-100 dark:shadow-none flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    t("saving")
                  ) : (
                    <>
                      <Check2 size={24} /> {t("update")}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerLedger;
